import React from 'react'
import { Field, reduxForm } from 'redux-form'
import styles from '../EkgRecordingReviewScreen.css'
import NumInput from '../../../containers/Forms/components/NumInput'
import TextAreaInput from '../../../containers/Forms/components/TextAreaInput'
import ReactSelectDropdownInput from '../../../containers/Forms/components/ReactSelectDropdownInput'
import Popover from '../../../containers/Popovers/components/Popover'
import FormattedDate from '../../../components/FormattedDate'
import Loading from '../../../components/Loading'
import {
  checkHideQTCorrectionType,
} from 'configs'
import {
  getQtErrorOptions,
  QT_ERROR_TYPES,
} from '../../../constants'

class QtValuesForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      saveConfirmShow: false,
    }
  }
  toggleConfirmPopover = e => {
    e.preventDefault()
    this.setState(prevState => ({
      saveConfirmShow: !prevState.saveConfirmShow,
    }))
  }
  cancelConfirm = () => {
    this.setState({
      saveConfirmShow: false,
    })
  }
  submitForm = () => {
    this.setState({
      saveConfirmShow: false,
    })
    this.props.handleSubmit()
  }
  maxMinValue = value => (value && ((value < 0) || (value > 999)) ? 'Must be greater then 0 and less then 999' : undefined)
  render() {
    const {
      handleSubmit,
      invalid,
      pristine,
      submitting,
      isSubmitting,
      handleOnSaveQtValues,
      qtFormData,
      isServiceProviderErrorFeatureEnabled,
      me,
      isServiceProviderEnabled,
      isServiceInterpretationFeatureEnabled,
    } = this.props

    const {
      saveConfirmShow,
    } = this.state

    const errorOptions = [ ...getQtErrorOptions() ]
    const otherErrorSelected = qtFormData && qtFormData.errorType && qtFormData.errorType.id === 'other'
    // condition on the basis of isServiceProviderEnabled and isServiceInterpretationFeatureEnabled
    const checkServiceProviderAndInterpretationProvider = isServiceProviderEnabled && !isServiceInterpretationFeatureEnabled
    const hideQTCorrectionType = me && checkHideQTCorrectionType(me)
    return (
      <form className={!checkServiceProviderAndInterpretationProvider ? styles.qtValueFormCss : ''} onSubmit={handleSubmit}>
        <div>
          <h2 className={!checkServiceProviderAndInterpretationProvider ? styles.qtValuesHeader : ''} >Enter values for QT Assessment</h2>
          <div className={styles.formSectionRow}>
            <Field
              component={NumInput}
              label="QT"
              name="qtVal.qt"
              type="number"
              min="0"
              validate={[ this.maxMinValue ]}
            />
            <Field
              component={NumInput}
              label="QTcf"
              name="qtVal.qtcf"
              type="number"
              min="0"
              validate={[ this.maxMinValue ]}
            />
          </div>
          <div className={styles.formSectionRow}>
            <Field
              component={NumInput}
              label="RR"
              name="qtVal.rr"
              type="number"
              min="0"
              validate={[ this.maxMinValue ]}
            />
            <Field
              component={NumInput}
              label={hideQTCorrectionType ? 'QTc:' : 'QTcb:'}
              name="qtVal.qtcb"
              type="number"
              min="0"
              validate={[ this.maxMinValue ]}
            />
          </div>
          {isServiceProviderErrorFeatureEnabled &&
            <React.Fragment>
              <div className={styles.formSectionRowFull}>
                <Field
                  component={ReactSelectDropdownInput}
                  label="Select Error Type"
                  name="errorType"
                  isClearable={true}
                  backspaceRemovesValue={false}
                  options={errorOptions}
                  getOptionLabel={p => p.label}
                  getOptionValue={p => p.id}
                />
              </div>
              {otherErrorSelected &&
                <div className={styles.formSectionRowFull}>
                  <Field
                    component={TextAreaInput}
                    label="Error Note"
                    type="text"
                    name="error"
                  />
                </div>
              }
            </React.Fragment>
          }
        </div>
        {/* ToDo after the api change */}
        {
          checkServiceProviderAndInterpretationProvider &&
          <div className={styles.stackControls}>
            <div className={styles.row}>
              <div className={styles.dropoverWrapper}>
                {!pristine && (submitting || isSubmitting) ?
                  <button disabled className={styles.submitLoading}>
                    <Loading />
                  </button>
                  :
                  <button type="submit" disabled={invalid || pristine} className={styles.confirmButton} onClick={e => this.toggleConfirmPopover(e)}>
                    Confirm
                  </button>
                }
                {!isServiceInterpretationFeatureEnabled && saveConfirmShow &&
                <Popover
                  onOutsidePopoverClick={() => this.cancelConfirm()}
                  className={styles.confirmDropover}
                >
                  <div className={styles.dropoverContent}>
                    <h2>
                      <b>
                        {'Confirm on '}<FormattedDate
                          overrideLastDay
                          overrideSameDay
                          date={new Date()}
                          me={me}
                        />
                      </b>
                    </h2>
                    <p>
                      By confirming, you will no longer be able to add QT values to this ECG.
                    </p>
                  </div>
                  <div className={styles.dropoverControls}>
                    <button
                      onClick={() => this.cancelConfirm()}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => this.submitForm()}
                    >
                      Confirm
                    </button>
                  </div>
                </Popover>
                }
              </div>
            </div>
          </div>
        }
      </form>
    )
  }
}

export default reduxForm({
  form: 'qtValuesForm',
  enableReinitialize: true,
})(QtValuesForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/components/QtValuesForm.jsx